export default __webpack_public_path__ + "static/media/articalThird.f6578055.png";